/**
 * Cart Store Implementation
 * Simple store pattern matching legacy implementation
 */

import { stateReducer } from './reducers/cartReducer';
import { CartAction, CartStateInterface } from './actions/cartActions';

/**
 * Simple Store Implementation (matching legacy nvstore)
 */
class CartStore {
  private state: CartStateInterface;
  private listeners: Array<(state: CartStateInterface) => void>;

  constructor() {
    this.state = stateReducer(undefined, { type: '@@INIT' });
    this.listeners = [];
  }

  /**
   * Get current state
   */
  getState(): CartStateInterface {
    return this.state;
  }

  /**
   * Dispatch an action
   */
  dispatch(action: CartAction): void {
    this.state = stateReducer(this.state, action);
    this.listeners.forEach(listener => listener(this.state));
  }

  /**
   * Subscribe to state changes
   */
  subscribe(listener: (state: CartStateInterface) => void): () => void {
    this.listeners.push(listener);
    
    // Return unsubscribe function
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }
}

// Create and export global store instance (matching the original nvstore)
export const nvstore = new CartStore();

// Make nvstore available globally for legacy compatibility
if (typeof window !== 'undefined') {
  (window as any).nvstore = nvstore;
}

// Export convenience methods
export const getCartState = () => nvstore.getState();
export const dispatchCartAction = (action: CartAction) => nvstore.dispatch(action);

